export default class Component {
    constructor(game, position, velocity) {
        this.visible = true;
        this.game = game;
        this.p5 = game.p5;
        this.position = position || this.p5.createVector(0, 0, 0);
        this.velocity = velocity || this.p5.createVector(0, 0, 0);
    }
    update() { }
    render() { }
    keyPressed(key) { }
    keyReleased(key) { }
}
